<script>
  import { onMount } from "svelte";
  import { ignore } from "./tools";
  import {External, M} from "../external";

  export let onChange = ignore,
    modal = true,
    allowEmptyCaption = true,
    allowFunnelStepPicking = true,
    hasNoFollow = false,
    target = "_self",
    nofollow = false,
    link = "";

  let displayText = "";

  let onClick = () => {
    External.Website.selectPage({
      allowEmptyCaption: allowEmptyCaption,
      modal: modal,
      allowFunnelStepPicking: allowFunnelStepPicking,
      hasNoFollow: hasNoFollow,
      selected: {
        link: link || "",
        target: target,
        nofollow: nofollow
      },
      onSelect: function(result) {
        target = result.target;
        nofollow = result.nofollow;
        link = result.link;
        onChange(result);
        displayText = External.LinkPicker.getLinkDisplayText(link, null, result);
      }
    });
  };

  onMount(() => {
    displayText = External.LinkPicker.getLinkDisplayText(link) || M.SELECT_PAGE_TITLE;
  });
</script>

<input class="path-select select-like col20" type="text" value={displayText} on:click={onClick} />
